import AlgoliaSearchInsights from 'search-insights'
import { v1 as uuid } from 'uuid'

import { env } from 'libs/environment/env'

export const initAlgoliaAnalytics = () => {
  AlgoliaSearchInsights('init', {
    appId: env.ALGOLIA_APPLICATION_ID,
    apiKey: env.ALGOLIA_SEARCH_API_PUBLIC_KEY,
  })

  AlgoliaSearchInsights('setUserToken', uuid())
}
